import request from '@/utils/request'

export function list(query) {
  return request({
    url: 'zucheOrderInfo/list',
    method: 'post',
    data: query
  })
}

export function postquche(data) {
  return request({
    url: 'zucheOrderInfo/quche',
    method: 'post',
    data
  })
}

export function posthuanche(data) {
  return request({
    url: 'zucheOrderInfo/huanche',
    method: 'post',
    data
  })
}

export function detail(data) {
  return request({
    url: 'zucheOrderInfo/detail',
    method: 'post',
    data
  })
}

export function gettuiyajininfo(data) {
  return request({
    url: 'zucheOrderInfo/tuiyajininfo',
    method: 'get',
    params: data
  })
}

export function tuiYajin(data) {
  return request({
    url: 'zucheOrderInfo/tuiYajin',
    method: 'post',
    data
  })
}


export function postxianxiazuche(data) {
  return request({
    url: 'zucheOrderInfo/xianxiazuche',
    method: 'post',
    data
  })
}

export function postRemove(data) {
  return request({
    url: 'zucheOrderInfo/remove',
    method: 'post',
    data
  })
}

export function postEdit(data) {
  return request({
    url: 'zucheOrderInfo/edit',
    method: 'post',
    data
  })
}

const index = {
  list,
  postquche,
  posthuanche,
  gettuiyajininfo,
  tuiYajin,
  postxianxiazuche,
  postEdit
}

export default index;
